<template>
  <v-dialog v-model="showForm" persistent max-width="500px">
    <v-card>
      <v-card-title>
        <span class="text-h5 gray--text">Terapêutica</span>
      </v-card-title>

      <v-card-text>
        <v-container fluid>
          <v-row dense>
            <v-col>
              <v-combobox
                v-model="medicine"
                outlined
                dense
                label="Medicamento"
                :items="medicines"
                item-text="name"
                :hide-details="errors.medicine === undefined"
                :error-messages="errors.medicine"
                background-color="white"
                @change="medicineChange"
                :disabled="disabled"
              />
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-combobox
                v-model="applicationRoute"
                outlined
                dense
                label="Via de aplicação"
                :items="applicationRoutes"
                item-text="name"
                :hide-details="errors.applicationRoute === undefined"
                :error-messages="errors.applicationRoute"
                @change="applicationSite = ''"
                background-color="white"
                :disabled="disabled"
              />
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-combobox
                v-model="applicationSite"
                outlined
                dense
                label="Local"
                :items="therapyApplicationSites"
                item-text="name"
                :hide-details="errors.applicationSite === undefined"
                :error-messages="errors.applicationSite"
                background-color="white"
                :disabled="disabled"
              />
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-combobox
                v-model="interval"
                outlined
                dense
                label="Intervalo"
                :items="intervals"
                item-text="name"
                :hide-details="errors.interval === undefined"
                :error-messages="errors.interval"
                background-color="white"
                :disabled="disabled"
              />
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-combobox
                v-model="numberOfApplications"
                outlined
                dense
                label="N° de aplicações"
                :items="numberOfApplicationsArray"
                item-text="name"
                :hide-details="errors.numberOfApplications === undefined"
                :error-messages="errors.numberOfApplications"
                background-color="white"
                :disabled="disabled"
              />
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="auto">
              <v-btn color="light-blue" dark @click="saveSurgeryTherapy">Salvar</v-btn>
            </v-col>

            <v-col cols="auto">
              <v-btn color="gray lighten-1" dark @click="cancelTherapy">
                cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "SurgeryTherapyForm",
    props: {
      surgery: Object,
      showSurgeryTherapyForm: {
        type: Boolean,
        default: false,
      },
      toggleShow: {
        type: Function,
        default: () => {},
      },
      surgeryMoment: {
        type: String,
        default: "",
      },
      refreshSurgery: Function,
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        errors: {},
        medicine: "",
        surgeryTherapy: "",
        applicationRoute: "",
        applicationSite: "",
        interval: "",
        numberOfApplications: "",
        intervals: [
          { name: "3 minutos", value: 3 },
          { name: "5 minutos", value: 5 },
          { name: "10 minutos", value: 10 },
          { name: "15 minutos", value: 15 },
          { name: "20 minutos", value: 20 },
          { name: "30 minutos", value: 30 },
          { name: "40 minutos", value: 40 },
          { name: "45 minutos", value: 45 },
          { name: "1 hora", value: 60 },
          { name: "2 horas", value: 120 },
          { name: "3 horas", value: 180 },
          { name: "4 horas", value: 240 },
          { name: "6 horas", value: 360 },
          { name: "8 horas", value: 420 },
          { name: "12 horas", value: 720 },
        ],
        numberOfApplicationsArray: [
          { name: "1 vez", value: 1 },
          { name: "2 vezes", value: 2 },
          { name: "3 vezes", value: 3 },
          { name: "4 vezes", value: 4 },
          { name: "5 vezes", value: 5 },
          { name: "6 vezes", value: 6 },
        ],
      };
    },
    apollo: {
      medicines: {
        query: require("@/graphql/medicine/medicines.gql"),
        variables: {
          disabled: false,
        },
        update({ medicines }) {
          return medicines.collection;
        },
      },
    },
    computed: {
      showForm: {
        get() {
          return this.showSurgeryTherapyForm;
        },
        set() {
          this.toggleShow();
        },
      },
      applicationRoutes() {
        if (this.medicines) {
          return this.medicine.applicationRoutes;
        }

        return [];
      },
      therapyApplicationSites() {
        if (this.applicationRoute) {
          return this.applicationRoute.applicationSites;
        }
        return [];
      },
    },
    methods: {
      validate() {
        const errorMsg = "Esse campo deve ser preenchido.";
        this.errors = {};

        if (!this.medicine?.id) {
          this.errors.medicine = errorMsg;
        }
        if (!this.applicationRoute?.id) {
          this.errors.applicationRoute = errorMsg;
        }
        if (!this.applicationSite?.id) {
          this.errors.applicationSite = errorMsg;
        }
        if (!this.interval?.value) {
          this.errors.interval = errorMsg;
        }
        if (!this.numberOfApplications?.value) {
          this.errors.numberOfApplications = errorMsg;
        }

        if (Object.keys(this.errors).length === 0) {
          return true;
        }

        return false;
      },
      saveSurgeryTherapy() {
        if (this.disabled) return;
        if (!this.validate()) return;

        return this.apolloMutate({
          mutation: require("@/graphql/surgery/save_surgery_therapy.gql"),
          variables: {
            surgeryId: this.surgery.id,
            surgeryTherapyId: this.surgeryTherapyId,
            medicineId: this.medicine.id,
            applicationRouteId: this.applicationRoute.id,
            applicationSiteId: this.applicationSite.id,
            interval: this.interval.value,
            numberOfApplications: this.numberOfApplications.value,
            surgeryMoment: this.surgeryMoment,
          },
        }).then(() => {
          this.cancelTherapy();

          this.refreshSurgery();
        });
      },
      cancelTherapy() {
        this.errors = {};
        this.medicine = "";
        this.surgeryTherapy = "";
        this.applicationRoute = "";
        this.applicationSite = "";
        this.interval = "";
        this.numberOfApplications = "";

        this.toggleShow();
      },
      medicineChange() {
        this.applicationRoute = "";
        this.applicationSite = "";

        if (this.applicationRoutes.length == 1) {
          this.applicationRoute = this.lodash.first(this.applicationRoutes);
        }

        if (this.therapyApplicationSites.length == 1) {
          this.applicationSite = this.lodash.first(this.therapyApplicationSites);
        }
      },
    },
  };
</script>

<style lang="scss" scoped></style>
